export default "__VITE_PUBLIC_ASSET__b7725a8e__"